import React from 'react';
import { motion } from 'framer-motion';
import { VisualStat } from './VisualStat';
import type { WorkStat } from '../../../types/work';
import { EASE_OUT } from '../../../utils/motion';
type Props = {
  stat?: WorkStat;
};
const BARS = [{
  h: 32,
  c: 'bg-ink-soft'
}, {
  h: 44,
  c: 'bg-ink-soft'
}, {
  h: 52,
  c: 'bg-ink-soft'
}, {
  h: 40,
  c: 'bg-ink-soft'
}, {
  h: 70,
  c: 'bg-ink'
}, {
  h: 86,
  c: 'bg-coral'
}];
export function VendooVisual({
  stat
}: Props) {
  return <div aria-hidden className="absolute inset-0 bg-surface" data-id="element-425" data-mp="2w9epttgtyqcm">
      {stat && <VisualStat stat={stat} tone="ink" data-id="element-426" data-mp="2w7bseodcluxv" />}
      <div className="absolute bottom-[12%] right-[8%] flex h-[62%] w-[52%] items-end gap-[6%]" data-id="element-427" data-mp="2ia6p2w50ra6b">
        {BARS.map((bar, i) => <motion.div key={i} className={`flex-1 rounded-t-md ${bar.c}`} style={{
        height: `${bar.h}%`,
        originY: 1
      }} initial={{
        scaleY: 0
      }} whileInView={{
        scaleY: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: EASE_OUT,
        delay: 0.1 + i * 0.05
      }} data-id="element-428" data-mp="2n99xmqk7jyj1" data-mpi={i} />)}
      </div>
    </div>;
}